import { render, staticRenderFns } from "./ServicePlatformTab.vue?vue&type=template&id=12a5a6e4&scoped=true"
import script from "./ServicePlatformTab.vue?vue&type=script&lang=js"
export * from "./ServicePlatformTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a5a6e4",
  null
  
)

export default component.exports